module.exports = __webpack_public_path__ + "static/omega-a1262fa62aa44edf276090c3a2e6fe80.png";